import { Component, OnInit, inject } from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {environment} from '../../environments/environment';
import {filter, map} from "rxjs/operators";
import {ISummary} from "../../shared/model/summary.model";
import { MatCard, MatCardTitle } from '@angular/material/card';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatDivider } from '@angular/material/list';

@Component({
    selector: 'app-summary',
    templateUrl: './summary.component.html',
    styleUrls: ['./summary.component.css'],
    imports: [MatCard, MatCardTitle, MatProgressSpinner, MatDivider]
})
export class SummaryComponent implements OnInit {
  private http = inject(HttpClient);
  private router = inject(Router);
  private toastr = inject(ToastrService);


  agency: string;
  businessName: string;
  city: string;
  customerContact: string;
  telephone: string;
  emailContact: string;
  company: string;
  isLoading = false;
  apiUrl = environment.apiUrl;
  siret: string;
  tiers: string;

  ngOnInit(): void {
    this.http.get<ISummary>(this.apiUrl + '/user/get-summary', {observe: 'response'})
      .pipe(
        filter((res: HttpResponse<ISummary>) => res.ok),
        map((res: HttpResponse<ISummary>) => res.body)
      )
      .subscribe((summary: ISummary) => {
        this.agency = summary.agency;
        this.businessName = summary.businessName;
        this.city = summary.city;
        this.customerContact = summary.customerContact;
        this.concatTelephone(summary.telephone1, summary.telephone2);
        this.emailContact = summary.emailContact;
        this.tiers = localStorage.getItem('tiers');
        this.siret = summary.siret;

        this.isLoading = false;
      }, () => {
        this.showError('Impossible de récupérer vos informations');
        this.isLoading = false;
      });
  }

  private concatTelephone(telephone1: string, telephone2: string) {
    this.telephone = [telephone1, telephone2].filter(v => v).join('/');
  }

  showError(error: string): void {
    this.toastr.error(error, 'Erreur', {
      timeOut: 3000
    });
  }
}
